<template>
  <Adminlte>
    <p>
      <button class="btn btn-sm btn-success" @click="createPark()"><i class="fa fa-plus"></i>&nbsp Novo</button>
    </p>
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">Parques Tecnológicos</h3>
      </div>
      <div class="box-body">
        <DataTables
          tableId="parks-table"
          :url="this.apiUrl"
          :columns="this.columns"
          :columnDefs="this.columnDefs">
        </DataTables>
      </div>
    </div>
    <notifier ref="notifier"></notifier>
    
    <div class="modal fade" id="recover-password-modal" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">Recuperar Senha</h4>
          </div>
          <div class="modal-body">
            <p>Ao clicar em "Ok" um link para criação de uma nova senha será enviado por email ao parque. Deseja continuar?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Cancelar</button>
            <button id="recover-password-modal-confirm" type="button" class="btn btn-primary" data-dismiss="modal">Ok</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="delete-park-modal" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">Excluir Parque</h4>
          </div>
          <div class="modal-body">
            <p>
              Ao clicar em "Ok" o parque será excluída do sistema, bem como seus respectivos questionários e empresas associadas. 
              Esta ação é irreversível! Deseja continuar?
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal">Cancelar</button>
            <button id="delete-park-modal-confirm" type="button" class="btn btn-primary" data-dismiss="modal">Ok</button>
          </div>
        </div>
      </div>
    </div>

  </Adminlte>
</template>

<script>
import Adminlte from '@/components/template/Adminlte'
import DataTables from '@/components/elements/DataTables'
import {BackendApi} from '@/services/backend_api'
import Notifier from '@/components/elements/Notifier'

export default {
  name: 'Parks',
  components: { Adminlte, DataTables, Notifier },
  data: function () {
    return {
      apiUrl: process.env.API_URL + 'parks',
      columns: [
        { label: 'Nome', field: 'name' },
        { label: 'Email', field: 'email' },
        { label: 'Estágio', field: 'currentStage' },
        { label: 'Opções', field: null }
      ],
      columnDefs: [
        {
          targets: -1,
          orderable: false,
          render: function (data, type, full, meta) {
            return `
            <button
              class="btn btn-xs btn-primary edit-park"
              data-park-id=` + data.id + `>
                <i class="fa fa-pencil"></i>&nbsp Editar
            </button>
            <button
              class="btn btn-xs btn-primary companies"
              data-park-id=` + data.id + `>
                <i class="fa fa-send"></i>&nbsp Empresas
            </button>
            <button
              class="btn btn-xs btn-primary general-informations"
              data-park-id=` + data.id + `>
                <i class="fa fa-info"></i>&nbsp Informações Gerais
            </button>
            <button
              class="btn btn-xs btn-danger delete-park"
              data-park-id=` + data.id + `
              data-toggle="modal"
              data-target="#delete-park-modal"
              >
                <i class="fa fa-trash"></i>&nbsp Excluir
            </button>
            <button
              class="btn btn-xs btn-warning recover-password"
              data-park-id=` + data.id + `
              data-toggle="modal"
              data-target="#recover-password-modal"
              >
                <i class="fa fa-unlock-alt"></i>&nbsp Recuperar Senha
            </button>
            `
          }
        }
      ],
      recoverPasswordParkId: '',
      deleteParkId: '',
      eventsBound: false
    }
  },
  mounted () {
    this.bindEditParkButtonClick()
    this.bindCompaniesButtonClick()
    this.bindGeneralInformationsButtonClick()
    this.bindDeleteParkButtonClick()
    this.bindConfirmDeletePark()
    this.bindRecoverPasswordButtonClick()
    this.bindConfirmPasswordRecovery()
  },
  methods: {
    createPark () {
      this.$router.push({name: 'CreatePark'})
    },
    bindEditParkButtonClick () {
      let that = this
      $('body').off('click', '.edit-park')
        .on('click', '.edit-park', function (e) {
          let parkId = $(this).data('park-id')
          that.editPark(parkId)
        })
    },
    editPark (id) {
      this.$router.push({name: 'EditPark', params: { id: id }})
    },
    bindCompaniesButtonClick () {
      let that = this
      $('body').off('click', '.companies')
        .on('click', '.companies', function (e) {
          let parkId = $(this).data('park-id')
          that.companies(parkId)
        })
    },
    companies (parkId) {
      this.$router.push({name: 'CompaniesHome', params: { parkId: parkId }})
    },
    bindGeneralInformationsButtonClick () {
      let that = this
      $('body').off('click', '.general-informations')
        .on('click', '.general-informations', function (e) {
          let parkId = $(this).data('park-id')
          that.generalInformations(parkId)
        })
    },
    generalInformations (parkId) {
      this.$router.push({name: 'GeneralInformations', params: { parkId: parkId }})
    },
    bindDeleteParkButtonClick () {
      let that = this
      $('body').off('click', '.delete-park')
        .on('click', '.delete-park', function (e) {
          that.deleteParkId = $(this).data('park-id')
        })
    },
    bindConfirmDeletePark () {
      let that = this
      $('body').off('click', '#delete-park-modal-confirm')
        .on('click', '#delete-park-modal-confirm', function (e) {
          that.deletePark()
        })
    },
    deletePark () {
      BackendApi.getClient().delete(`parks/${this.deleteParkId}`)
        .then(response => {
          this.reloadTable()
          this.showParkDeleteSuccessNotification()
        })
        .catch(e => {
          this.showParkDeleteErrorNotification()
        })
    },
    reloadTable () {
      $('#parks-table').DataTable().ajax.reload()
    },
    showParkDeleteSuccessNotification () {
      this.$notify({ type: 'success', title: 'Sucesso', text: 'O parque foi excluído do sistema!' })
    },
    showParkDeleteErrorNotification () {
      this.$notify({ type: 'error', title: 'Erro', text: 'Ocorreu um erro ao excluir o parque! Entre em contato com a equipe de desenvolvimento.' })
    },
    bindRecoverPasswordButtonClick () {
      let that = this
      $('body').off('click', '.recover-password')
        .on('click', '.recover-password', function (e) {
          that.recoverPasswordParkId = $(this).data('park-id')
        })
    },
    bindConfirmPasswordRecovery () {
      let that = this
      $('body').off('click', '#recover-password-modal-confirm')
        .on('click', '#recover-password-modal-confirm', function (e) {
          that.recoverParkPassword()
        })
    },
    recoverParkPassword () {
      BackendApi.getClient().put(`users/park-password-recovery/${this.recoverPasswordParkId}`)
        .then(response => { })
        .catch(e => { throw e })
    }
  }
}
</script>



// WEBPACK FOOTER //
// Parks.vue?1c669dbc